import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=c0142892&scoped=true"
import script from "./brand.vue?vue&type=script&lang=js"
export * from "./brand.vue?vue&type=script&lang=js"
import style0 from "./brand.vue?vue&type=style&index=0&id=c0142892&prod&lang=scss&scoped=true"
import style1 from "./brand.vue?vue&type=style&index=1&id=c0142892&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0142892",
  null
  
)

export default component.exports